export interface UserPasswordChangeRequestModel {
  password: string;
  newPassword: string;
}
